import PropTypes from 'prop-types'
import { Modal, Tag, Spin } from 'antd'
import moment from 'moment'

const pretty = (value) => {
  if (value === null || value === undefined) return '-'
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value, null, 2)
  } catch (e) {
    return String(value)
  }
}

const statusTag = (status) => {
  if (status === 'success') return <Tag color="green">success</Tag>
  if (status === 'failed') return <Tag color="red">failed</Tag>
  return <Tag>-</Tag>
}

const preStyle = {
  background: '#f6f8fa',
  padding: 12,
  maxHeight: 320,
  overflow: 'auto',
  fontSize: 12,
  whiteSpace: 'pre',
}

const infoRows = data => [
  { label: 'API', value: data.api_name || '-' },
  { label: 'Method', value: data.method || '-' },
  {
    label: 'Status',
    value: (
      <span>
        {statusTag(data.status)}
        {data.http_status ? `HTTP ${data.http_status}` : ''}
      </span>
    ),
  },
  { label: 'Endpoint', value: data.url || '-' },
  { label: 'Service', value: data.service || '-' },
  { label: 'Referensi', value: data.reference || '-' },
  { label: 'Tanggal', value: data.created_at ? moment(data.created_at).format('DD MMM YYYY HH:mm:ss') : '-' },
  { label: 'Durasi', value: data.duration_ms !== undefined ? `${data.duration_ms} ms` : '-' },
]

const DetailBody = ({ data }) => (
  <div>
    <table className="table table-sm table-borderless mb-3">
      <tbody>
        {infoRows(data).map(row => (
          <tr key={row.label}>
            <th style={{ width: 140 }}>{row.label}</th>
            <td style={{ wordBreak: 'break-all' }}>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
    {data.error_message && (
      <div className="mb-3">
        <h6>Error Message</h6>
        <pre style={{ ...preStyle, whiteSpace: 'pre-wrap', color: '#c0392b' }}>{data.error_message}</pre>
      </div>
    )}
    <div className="mb-3">
      <h6>Request Payload</h6>
      <pre style={preStyle}>{pretty(data.request_payload)}</pre>
    </div>
    <div>
      <h6>Response Core</h6>
      <pre style={preStyle}>{pretty(data.response_body)}</pre>
    </div>
  </div>
)

DetailBody.propTypes = {
  data: PropTypes.object,
}

const CoreApiLogDetailModal = ({
  visible, loading, data, onClose,
}) => (
  <Modal
    title="Detail Log API Core"
    visible={visible}
    onCancel={onClose}
    footer={null}
    width={900}
  >
    {loading || !data
      ? <div className="text-center p-4"><Spin /></div>
      : <DetailBody data={data} />
    }
  </Modal>
)

CoreApiLogDetailModal.propTypes = {
  visible: PropTypes.bool,
  loading: PropTypes.bool,
  data: PropTypes.object,
  onClose: PropTypes.func,
}

export default CoreApiLogDetailModal
